import { render, staticRenderFns } from "./SessionsPage.vue?vue&type=template&id=c2f0b4fc&scoped=true&"
import script from "./SessionsPage.vue?vue&type=script&lang=js&"
export * from "./SessionsPage.vue?vue&type=script&lang=js&"
import style0 from "./SessionsPage.vue?vue&type=style&index=0&id=c2f0b4fc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2f0b4fc",
  null
  
)

export default component.exports